import {
	connect
} from 'react-redux'
import FittingOrdererEditComponent from '../components/FittingOrdererEditComponent.jsx';
import {
	findAllFirefighterTypes,
	changeOrdererValue,
	addOrderer,
	editOrderer,
	clearFittingOrdererAlert
} from '../actions';

const mapStateToProps = (state) => ({
	orderer: state.getIn(['fittingReducer', 'orderer']),
	ordererValidation: state.getIn(['fittingReducer', 'ordererValidation']),
	allFirefighterTypes: state.getIn(['commonReducer', 'allFirefighterTypes']),
	alertStyle: state.getIn(['fittingReducer', 'alertStyle']),
	alertMessage: state.getIn(['fittingReducer', 'alertMessage']),
	forInsert: state.getIn(['fittingReducer', 'forInsert']),

	activePage: state.getIn(['fittingListReducer', 'activePage']),
	itemPerPage: state.getIn(['fittingListReducer', 'itemPerPage'])
})

const mapDispatchToProps = (dispatch) => ({
	editOrderer: (orderer, pagingData, forInsert) => {
		if (forInsert) {
			dispatch(addOrderer(orderer, pagingData));
		} else {
			dispatch(editOrderer(orderer, pagingData));
		}
	},
	findAllFirefighterTypes: () => {
		dispatch(findAllFirefighterTypes());
	},
	setValue: (id, value) => {
		dispatch(changeOrdererValue({
			id: id,
			value: value
		}))
	},
	clearOrdererAlert: () => {
		dispatch(clearFittingOrdererAlert());
	},
})

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
	orderer: stateProps.orderer,
	ordererValidation: stateProps.ordererValidation,
	allFirefighterTypes: stateProps.allFirefighterTypes,
	alertStyle: stateProps.alertStyle,
	alertMessage: stateProps.alertMessage,
	forInsert: stateProps.forInsert,
	editOrderer: () => dispatchProps.editOrderer(stateProps.orderer, {
		activePage: stateProps.activePage,
		itemPerPage: stateProps.itemPerPage
	}, stateProps.forInsert),
	findAllFirefighterTypes: dispatchProps.findAllFirefighterTypes,
	setValue: dispatchProps.setValue,
	clearOrdererAlert: dispatchProps.clearOrdererAlert
})

const FittingOrdererEditContainer = connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps
)(FittingOrdererEditComponent)

export default FittingOrdererEditContainer;


// WEBPACK FOOTER //
// ./src/containers/FittingOrdererEditContainer.jsx